// api/groceriesApi.js - ACTUALIZADO CON ENDPOINT DE CATEGORÍAS
import { getAuthHeaders } from './authApi';
import { API_BASE_URL } from '../config/apiConfig';
import { parseApiResponse } from './apiResponse';

const groceriesApi = {
  fetchList: async () => {
    const response = await fetch(`${API_BASE_URL}groceries-list.php`, {
      headers: getAuthHeaders(),
    });
    return parseApiResponse(response);
  },

  fetchCategories: async () => {
    const response = await fetch(`${API_BASE_URL}groceries-categories.php`, {
      headers: getAuthHeaders(),
    });
    return parseApiResponse(response);
  },

  insertItem: async (itemData) => {
    const response = await fetch(`${API_BASE_URL}groceries-insert.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(itemData)
    });
    return parseApiResponse(response);
  },

  editItem: async (itemData) => {
    const response = await fetch(`${API_BASE_URL}groceries-edit.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(itemData)
    });
    return parseApiResponse(response);
  },

  deleteItem: async (id) => {
    const response = await fetch(`${API_BASE_URL}groceries-delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id: id.toString() })
    });
    return parseApiResponse(response);
  }
};

export { groceriesApi };